<template>
    <Card class="IncomeChart">
        <div class="header">
            <div>
                <strong>Income</strong>
                <h2>{{ 1000000 | formatCurrency }}</h2>
            </div>
            <span>Last 12 months</span>
        </div>

        <canvas id="IncomeChart"></canvas>
    </Card>
</template>

<script>
import Chart from 'chart.js';
import Card from '@/components/Card';

export default {
    name: 'IncomeChart',

    components: { Card },

    mounted() {
        const ctx = document.getElementById('IncomeChart');

        new Chart(ctx, {
            type: 'line',

            data: {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                datasets: [
                    {
                        label: 'Income',
                        borderColor: '#16DB97',
                        data: [0, 0, 0, 0, 0, 0, 50, 480, 1700, 2100, 4200, 3600],
                        fill: false,
                    },
                ],
            },

            options: {
                legend: false,
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: false,
                        },
                        ticks: {
                            maxTicksLimit: 6,
                        },
                    }],
                    yAxes: [{
                        gridLines: {
                            drawBorder: false,
                        },
                        ticks: {
                            maxTicksLimit: 6,
                            padding: 10,
                            callback: function(value, index, values) {
                                return '$' + value;
                            },
                        },
                    }],
                }
            },
        });
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.IncomeChart {
    padding: $grid-gutter-width;

    .header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        h2 {
            font-weight: $font-weight-regular;
        }

        span {
            margin-top: 2px;
            font-size: 14px;
        }
    }
}
</style>